import React from "react";
import AppSidebar from "./AppSidebar";
import {
  faUsers, faPlusCircle, faPenToSquare, faFileInvoiceDollar,
} from "@fortawesome/free-solid-svg-icons";

const NAV_ITEMS = [
  { href: "/vendors",      label: "Vendors List",  icon: faUsers,             exact: true },
  { href: "/vendors/new",  label: "Add Vendor",    icon: faPlusCircle },
  { href: "/rfqs/new",     label: "Add RFQ",       icon: faPenToSquare },
  { href: "/vendors/rfqs", label: "Manage RFQs",   icon: faFileInvoiceDollar },
];

export default function VendorSide() {
  return <AppSidebar navItems={NAV_ITEMS} />;
}
